import { DateTime } from "luxon";

export const getStartDateTime = (obj: { startTime: string | null }) => {
  if (!obj.startTime) return DateTime.invalid("start date not found");

  return DateTime.fromISO(obj.startTime);
};

export default getStartDateTime;
